import React, { createRef } from "react";
import { IBaseComponentProps } from "../props/IBaseComponentProps";
import { NSBoxDynamic } from "./NSBoxDynamic";
import { BaseVariableSchema } from "namirasoft-schema";

export interface NSBoxDynamicsProps extends IBaseComponentProps
{
	name: string;
	variables: BaseVariableSchema[] | null;
}

export interface NSBoxDynamicsState
{
}

export class NSBoxDynamics extends React.Component<NSBoxDynamicsProps, NSBoxDynamicsState>
{
	private NSBoxDynamic_Refs: { [name: string]: React.RefObject<NSBoxDynamic> } = {};
	constructor(props: NSBoxDynamicsProps)
	{
		super(props);
		this.state = {}
		this.getValues = this.getValues.bind(this);
		this.setValues = this.setValues.bind(this);

		(props.variables ?? []).forEach(variable =>
		{
			this.NSBoxDynamic_Refs[variable.name] = createRef<NSBoxDynamic>();
		});
	}

	getValues(checkError: boolean = true): { [name: string]: any } 
	{
		let ans: { [name: string]: string } = {};
		(this.props.variables ?? []).forEach(variable =>
		{
			ans[variable.name] = this.NSBoxDynamic_Refs[variable.name].current?.getValue(checkError) ?? "";
		});
		return ans;
	}

	setValues(values: { [name: string]: any }, callback?: () => void): void
	{
		(this.props.variables ?? []).forEach(variable =>
		{
			this.NSBoxDynamic_Refs[variable.name].current?.setValue(values[variable.name]);
		});
		callback?.();
	}

	override render()
	{
		return (
			<>
				{
					(this.props.variables ?? []).map((variable, index) =>
						<NSBoxDynamic
							ref={this.NSBoxDynamic_Refs[variable.name]}
							{...this.props}
							name={`${this.props.name}_${index}`}
							title=""
							variable={variable}
						/>
					)
				}
			</>
		);
	}
}